import type { STGGlobalKnowledgeDocument } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "stg_global_knowledge";

export const stgGlobalKnowledgeColumns = [
    createStringColumn<STGGlobalKnowledgeDocument>({
        namespace,
        field: "metadata.name",
        header: "File Name",
    }),
    createStringColumn<STGGlobalKnowledgeDocument>({
        namespace,
        field: "metadata.relative_path",
        header: "Relative Path",
        overrides: { size: 300 },
    }),
    createLinkColumn<STGGlobalKnowledgeDocument>({
        namespace,
        field: "metadata.source",
        header: "Source",
    }),
    createStringColumn<STGGlobalKnowledgeDocument>({
        namespace,
        field: "metadata.is_scanned",
        header: "Is Scanned",
        accessor: (row) => {
            const value = row._source?.metadata?.is_scanned ?? row.fields?.is_scanned;
            return value === true ? "Yes" : value === false ? "No" : "N/A";
        },
    }),
    createDateColumn<STGGlobalKnowledgeDocument>({
        namespace,
        field: "metadata.lastModifiedDateTime",
        header: "Last Modified",
    }),
    createDateColumn<STGGlobalKnowledgeDocument>({
        namespace,
        field: "metadata.ingestion_date",
        header: "Ingestion Date",
    }),
];
